import * as React from "react";
import {Link} from "react-router-dom";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {IWithRouterProps, withRouter} from "@athena-portal/components";
import {resourcesHelper} from "@falcon/services";
import * as Driver from "driver.js";

interface IProps {
    id?: string;
    src: string;
    alt: string;
    to: string;
    additionalText?: string;
    openInNewWindow?: boolean;
    notification?: boolean;
    status?: string;
    className?: string;
    routeState?: any;
    hasInfoButton?: boolean;
    infoModalBulletPoints?: string[];
    infoModalBulletPointTitle?: string;
    infoModalTitle?: string;
    infoModalAdditionalDescription?: React.ReactNode;
    infoModalButton?: string;
    infoModalButtonHidden?: boolean;
    linkDisabled?: boolean;
    backButtonName?: string;
    backButtonHidden?: boolean;
    badgeText?: React.ReactNode;
    mobileBadgeText?: React.ReactNode;
    tourDriver?: Driver;
}

interface IState {
    isOpen: boolean;
}

export class ImgTileLinkPlain extends React.Component<IWithRouterProps & React.PropsWithChildren<IProps>, IState> {

    public constructor(props: IWithRouterProps & React.PropsWithChildren<IProps>) {
        super(props);
        this.state = {
            isOpen: false
        };

        this.toggleInfoModal = this.toggleInfoModal.bind(this);
        this.proceedToLink = this.proceedToLink.bind(this);
    }

    public render() {
        const {
            id, to, src, alt, additionalText, children, notification,
            className, routeState, status,
            infoModalTitle, hasInfoButton,
            infoModalButton, infoModalBulletPointTitle, infoModalAdditionalDescription, linkDisabled, infoModalButtonHidden, backButtonHidden, backButtonName, badgeText, mobileBadgeText
        } = this.props;
        const targetProp: string = this.props.openInNewWindow ? '_blank' : '';

        return (
            <>
                <Link id={id || ""}
                      to={to}
                      state={routeState}
                      target={targetProp}
                      onClick={e => linkDisabled ? this.showInfoDialog(e) : this.props.tourDriver?.reset()}
                      className={`img-tile-link ${className || ""} ${!!status && "with-status"}`}>
                        {notification && <div className="notification"/>}
                        {badgeText && <div className="tile-badge d-none d-md-block">{badgeText}</div>}
                        {mobileBadgeText && <div className="tile-badge-mobile block d-md-none">{mobileBadgeText}</div>}
                        {!!status && <div className={`status ${status}`}>{status}</div>}
                        <img src={src} alt={alt}/>
                        <div className="link-name">
                            <span className={resourcesHelper.THEME !== "Allianz" ? "text-decoration-underline" : ""}>{children}</span>
                            {hasInfoButton &&
                                <div className={`info-button cursor-pointer ${this.props.className}`}
                                     onClick={e => this.showInfoDialog(e)}/>}
                        </div>
                    {additionalText && (
                        <div className="link-additional-text">
                            {additionalText}
                        </div>
                    )}

                </Link>
                <Modal className="my-2 tile-link-info-modal" isOpen={this.state.isOpen} toggle={this.toggleInfoModal}>
                    <ModalHeader toggle={this.toggleInfoModal}>
                        <div className="d-flex">
                            <img className="info-icon-selected" src="/img/Flow-info-selected.svg"/>
                            <div className="text-blue-2 font-weight-medium">{infoModalTitle}</div>
                        </div>
                    </ModalHeader>
                    <ModalBody className="pt-0">
                        <h3 className="mb-3 font-weight-600">{infoModalBulletPointTitle ?? "What can I do here?"}</h3>
                        {infoModalAdditionalDescription}
                        {this.renderBulletPoints()}
                    </ModalBody>
                    <ModalFooter>
                        {!backButtonHidden &&
                        <Button className="my-2 w-100 float-right" color="btn btn-white"
                                onClick={this.toggleInfoModal}>
                            {backButtonName ?? "Back"}
                        </Button>
                        }
                        {!infoModalButtonHidden &&
                        <Button className="my-2 px-4 w-100 float-right btn-link"
                                color={
                                    resourcesHelper.THEME === "Allianz"
                                        ? "btn btn-primary btn-next-no-arrow"
                                        : "btn btn-primary btn-next-no-arrow text-decoration-none"
                                } onClick={this.proceedToLink}>
                            {infoModalButton ? infoModalButton : infoModalTitle}
                        </Button>
                        }
                    </ModalFooter>
                </Modal>
            </>
        );
    }

    private renderBulletPoints() {
        const bulletPoints = this.props.infoModalBulletPoints || [];
        return (
            <ul className="info-modal-bullet-points">
                {bulletPoints.map((point) => (
                    <li key={point} className="margin-bottom-16">
                        <img className="info-modal-tick-icon" src="/img/tick.svg" alt="Green Tick"/>
                        {point}
                    </li>
                ))}
            </ul>
        );
    }

    private showInfoDialog(event: any): void {
        event.stopPropagation();
        event.preventDefault();
        this.props.tourDriver?.reset();
        this.toggleInfoModal();
    };

    private proceedToLink(): void {
        const {to, routeState} = this.props;
        if (/^https?:\/\//.test(to)) {
            // It's an external URL, use window.location.href to navigate
            window.open(to, '_blank');
        } else {
            this.props.navigate(to, routeState);
        }

        this.toggleInfoModal();
    };

    private toggleInfoModal(): void {
        this.setState((state: IState) => ({
            isOpen: !state.isOpen
        }));
    }
}

export const ImgTileLink = withRouter<React.PropsWithChildren<IProps>>(ImgTileLinkPlain)
